import React from 'react'

import Modal from '../../components/common/modal'

import BusLogo from '../../images/bitmap.jpg'
import HeadPhone from '../../images/head-phone.svg'
import SearchIcon from '../../images/search-icon.svg'
import DownArrow from '../../images/down-arrow.svg'
import { opdbGTM } from '../../utils/pulseUtils'
import EscalationMatrix  from '../escalationMatrix';

export default class AppHeader extends React.Component {

  state = {
    isDropdownOpen: false,
    isSupportModalOpen: false,
  }

  onLogoutClick = () => {/*console.log('onLogoutClick');*/ this.props.onLogoutClick(); }

  openDropdown = (e) => {
    e.stopPropagation();
    // console.log('openDropdown');
    // if(!this.state.isDropdownOpen)
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

  closeDropdown = (e) => this.setState({ isDropdownOpen: false })

  onOpenSupportModalClick = () => {
    this.props.getEscalationMatrixInfo();
    this.setState({ isSupportModalOpen: true })
  }

  onCloseClick = () => this.setState({ isSupportModalOpen: false })

  render() {
    const { operator_name = 'User'} = this.props.allRoutesInfo || {};
    const { escalationMatrix } = this.props;
    return (
      <div className="row appHeader">
        <div className="col-xs-2" style={{ textAlign: 'center' }}>
          <img className="bus-logo" src={BusLogo} alt="bus-logo" />
        </div>
        <div className="col-xs-4 searchWrp hide">
          <img src={SearchIcon} alt="search-icon" />
          <input autoComplete="off" className="search-box" placeholder="Search" />
        </div>
        <div className="col-xs-3" />
        <div className="col-xs-3 centerAlign" style={{ position: 'relative' }}>
          <img src={HeadPhone} className="col-xs-2 support-icon" alt="head-phone" onClick={this.onOpenSupportModalClick} />
          <div className="col-xs-8 centerAlign profile-dropdown" style={{ justifyContent: "flex-end" }} onClick={this.openDropdown}>
            <div className="user-icon" style={{ marginRight: 15 }}>{operator_name[0]}</div>
            <span className="operator-name">{operator_name}</span>
            <img src={DownArrow} alt="down-arrow" style={{ marginLeft: 5 }} />
          </div>
          {this.state.isDropdownOpen &&
            <ul className="list-wrapper">
              <li className="list-item" onClick={this.onLogoutClick}>Logout</li>
            </ul>
          }
        </div>
        {this.state.isSupportModalOpen &&
          <Modal classes="transparent" overlay>
            <EscalationMatrix 
              onClick={this.onCloseClick}
              escalationMatrix={escalationMatrix}
            />
          </Modal>
        }
      </div>
    )
  }
}
